<body>
<div style="display: flex;">
    <div class="headerContratos">
        <div class="align-left search">
            <button mat-button (click)="editDialog('')">
                <span class="material-icons">note_add</span> Adicionar Veículo
            </button>
        </div>
    </div>
    <div class="headerContratos">
        <h3 class="subtitulo">Veículos</h3>
    </div>
</div>
    <ul>
        <table class="tabelaDados">
            <thead>
                <tr>
                    <th>Modelo</th>
                    <th>Transportadora</th>
                    <th>Perfil</th>
                    <th>Combustível</th>
                    <th>Capacidade Volumetrica</th>
                    <th>Capacidade Peso</th>
                    <th>Consumo</th>
                    <th>Emissão</th>
                    <th>Editar</th>

                </tr>
            </thead>
            <tbody *ngFor="let item of items">
                <tr [ngClass]="{ 'black-row': $even, 'grafiti-row': $odd }">
                    <td>{{ item.modelo }}</td>
                    <td>{{ item.transportadora }}</td>
                    <td>{{ item.perfil }}</td>
                    <td>{{ item.combustivel }}</td>
                    <td>{{ item.volume }}</td>
                    <td>{{ item.peso }}</td>
                    <td>{{ item.consumo }}</td>
                    <td>{{ item.emissoes }}</td>
                    <td>
                        <i-feather name="edit" (click)="editDialog(item)"></i-feather>
                        <span style="margin-left: 10px; margin-right: 10px;"></span>
                        <i-feather name="delete" (click)="deleteItem(item.ID, urlConsulta, query3)"
                            class="button-spacing"></i-feather>
                    </td>
                </tr>
            </tbody>
        </table>
    </ul>
</body>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h2 class="modal-title">Cadastrar Tipo de Veículo</h2>
    <div class="modal-body">
        <form class="inputs">
            <table>
                <tr class="formEdicao">
                    <td class="camposForm">
                        <label class="modal-label">Modelo</label>
                    </td>
                    <td class="align-left input-maior">
                        <input type="string" name="modelo" [(ngModel)]="item.modelo" class="modal-input1">
                    </td>
                    <td class="camposForm">
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="camposForm">
                        <select id="transportadora" name="transportadora" [(ngModel)]="item.transportadora"
                            class="modal-select">
                            <option *ngFor="let transportadora of carrier" [value]="transportadora.name">{{
                                transportadora.name }}
                            </option>
                        </select>
                    </td>
                </tr>
                <tr class="titulosForm">
                    <td class="selectStatus camposForm">
                        <label class="modal-label">Perfil</label>
                    </td>
                    <td class="selectStatus camposForm">
                        <select id="perfil" name="perfil" [(ngModel)]="item.perfil" class="modal-select1">
                            <option *ngFor="let perfil of perfilVehicles" [value]="perfil">{{ perfil }}
                            </option>
                        </select>
                    </td>
                    <td class="selectStatus camposForm">
                        <label class="modal-label">Volume</label>
                    </td>
                    <td class="selectStatus camposForm">
                        <input type="string" name="volume" [(ngModel)]="item.volume" class="modal-input5">
                    </td>
                </tr>
                <tr class="titulosForm">
                    <td class="selectStatus camposForm">
                        <label class="modal-label">Peso</label>
                    </td>
                    <td class="selectStatus camposForm">
                        <input type="string" name="peso" [(ngModel)]="item.peso" class="modal-input5">
                    </td>
                    <td class="quinze% camposForm">
                        <label class="modal-label">Combustivel</label>
                    </td>
                    <td class="camposForm">
                        <select id="combustivel" name="combustivel" [(ngModel)]="item.combustivel"
                            class="modal-select1">
                            <option *ngFor="let combustivel of combustiveis" [value]="combustivel">{{ combustivel }}
                            </option>
                        </select>
                    </td>
                </tr>
                <tr class="titulosForm">

                    <td class="camposForm">
                        <label class="modal-label">Consumo</label>
                    </td>
                    <td>
                        <input type="string" name="consumo" [(ngModel)]="item.consumo" class="modal-input5">
                    </td>
                    <td class="camposForm">
                        <label class="modal-label">Emissões</label>
                    </td>
                    <td class="camposForm">
                        <input type="string" name="emissoes" [(ngModel)]="item.emissoes" class="modal-input5">
                    </td>
            </table>
            <div class="modal-div botoes">

                <button class="modal-button" type="button" (click)="salvarVeiculo()">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>